import { FormGroup } from "@angular/forms";
import { TimeFormat } from "../enums/time-format.enum";

/* eslint-disable no-bitwise */
export class Utils {

    constructor() { }

    public static interfaceOf<T>(value: any, fieldName: string): value is T {
        return fieldName in value;
    }

    static generateRandomId(length = 8) {
        let id = '';
        let dt = new Date().getTime();
        for (let i = 0; i < length; i++) {
            const r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            id += r.toString(16);
        }
        return id;
    }

    /**
     * @description Devuelve si un carácter es letra o no.
     */
    public static isCharacterALetter(character): boolean {
        return character.length === 1 && character.match(/[a-z]/i);
    }

    /**
     * @description Devuelve si un carácter es un número.
     */
    public static isCharacterANumber(character): boolean {
        return character.length === 1 && character.match(/[0-9]/i);
    }

    public static removeAccents(str: string) {
        return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    public static allControlsEmpty(form: FormGroup): boolean {
        if (!form || !form.controls) {
            return true;
        }
        return Object.values(form.controls).every(control => {
            const value = control.value;
            return value === null || value === undefined || value === '';
        });
    }

    public static minutesDisplay(minutes: number, timeFormat: TimeFormat): string {
        if (timeFormat === TimeFormat.HOURS_MINUTES) {
            let negative = false;
            if (minutes < 0) {
                negative = true;
                minutes = Math.abs(minutes);
            }
            const hours = Math.floor(minutes / 60);
            let str = '';
            minutes = minutes % 60;
            if (hours > 0) {
                str = str + String(hours) + 'h ';
            }
            if (minutes > 0) {
                str = str + String(minutes) + 'm';
            }
            if (str === '') {
                return '0m';
            } else {
                return negative ? '-' + str : str;
            }
        }
        return parseFloat((minutes / 60).toFixed(2)).toString();
    }

    // formatos de strings: 2025-07-29 o 2025-07. Si es invalido, devuelve nuevo date
    public static stringToDate(dateStr: string): Date | null {
        if (!dateStr) return new Date();
        
        const parts = dateStr.split('-');
        
        if (parts.length === 3) {
            const [year, month, day] = parts.map(Number);
            return new Date(year, month - 1, day);
        } else if (parts.length === 2) {
            const [year, month] = parts.map(Number);
            return new Date(year, month - 1, 1);
        }
        
        return new Date();
    }
}
